import gql from 'graphql-tag';

import taskFragment from '../fragments/taskFragment';

export const mutationUpdateTask = gql`
  mutation updateTask (
    $id: DokkioID!
    $name: String
    $description: String
    $dueAt: DateTime
    $completedAt: DateTime
  ) {
    updateTask (
      id: $id
      name: $name
      description: $description
      dueAt: $dueAt
      completedAt: $completedAt
    ) {
      ...taskFragment
    }
  }
  ${taskFragment}
`;
export default mutationUpdateTask;
